var map = {
	"./Case_Havelaar_1920x1080_1.png": 94971,
	"./Case_Havelaar_1920x1080_2.png": 39936,
	"./Case_Havelaar_1920x1080_3.png": 94761,
	"./Case_Havelaar_1920x1080_4.png": 20502,
	"./Case_Havelaar_1920x1080_5.png": 98591,
	"./Case_Havelaar_1920x1080_6.png": 85028,
	"./Case_Havelaar_1920x1080_7.png": 27533,
	"./Case_Havelaar_1920x1080_8.png": 23674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82954;